import { Maybe, SanitySlug, Scalars } from '../../graphql/gatsby'
import { resourceTypeUrlMapping } from '../../utils/libraryTools'
import { userCategories, UserCategory } from '../../utils/userClaims'
import { ResourceTypeSlug } from './types'

export const libraryAssetsUrlSeparator = '---'

export const libraryUrl = '/research-education/library'

export const professionalCategories: UserCategory[] = [
  userCategories.employee,
  userCategories.practitioner,
  userCategories.otherProfessional,
]

// excludes webinar
export const assetResourceTypeSlug: ResourceTypeSlug[] = [
  'case-study',
  'catalog-training',
  'category-brochure',
  'journal-article',
  'literature-reference',
  'patient-brochure',
  'patient-education',
  'private-label-form',
  'product-reference-chart',
  'protocol',
  'social-media-resource',
  'tech-sheet',
  'tech-sheet-french',
  'price-list',
  'white-paper',
]

export const publicTypeSlugs: ResourceTypeSlug[] = ['patient-brochure', 'patient-education']

export const professionalTypeSlugs: ResourceTypeSlug[] = [
  'case-study',
  'catalog-training',
  'category-brochure',
  'journal-article',
  'literature-reference',
  'patient-brochure',
  'patient-education',
  'private-label-form',
  'product-reference-chart',
  'protocol',
  'social-media-resource',
  'tech-sheet',
  'tech-sheet-french',
  'price-list',
  'white-paper',
  'webinar',
]

export const isUserCategoryProfessional = (userCategory?: UserCategory): boolean => {
  return !!userCategory && professionalCategories.indexOf(userCategory) > -1
}

export const buildResourceAssetUrl = (typeSlug: string, resourceSlug: string): string => {
  return `/api/library-assets/${typeSlug}${libraryAssetsUrlSeparator}${resourceSlug}`
}

export const isValidAssetResourceTypeSlug = (typeSlug: string): typeSlug is ResourceTypeSlug => {
  return (assetResourceTypeSlug as string[]).indexOf(typeSlug) >= 0
}

export const isPublicResourceTypeSlug = (typeSlug: ResourceTypeSlug): boolean => {
  return publicTypeSlugs.indexOf(typeSlug) >= 0
}

export const isProfessionalResourceTypeSlug = (typeSlug: ResourceTypeSlug): boolean => {
  return professionalTypeSlugs.indexOf(typeSlug) >= 0
}

export const hasResourceAssetPage = ({
  _type: type,
}: {
  _type?: Maybe<Scalars['String']>
}): boolean =>
  type === 'casiSession' ||
  type === 'socialMediaResource' ||
  type === 'webinar' ||
  type === 'protocol'

export const getResourceAssetUrl = (resource: {
  _type?: Maybe<Scalars['String']>
  slug?: Maybe<Pick<SanitySlug, 'current'>>
}): string => {
  if (resource.slug && resource.slug.current) {
    const {
      slug: { current: resourceSlug },
      _type: type,
    } = resource
    const found = Object.entries(resourceTypeUrlMapping).find(([, resourceType]) => {
      return resourceType === type
    })
    if (found) {
      const [typeSlug] = found
      if (typeSlug === 'webinar') {
        return `/research-education/library/webinar/${resourceSlug}`
      }
      if (typeSlug === 'social-media-resource') {
        return `/research-education/library/social-media-resource/${resourceSlug}`
      }
      if (typeSlug === 'casi-session') {
        return `/research-education/library/casi-session/${resourceSlug}`
      }
      if (typeSlug === 'protocol') {
        return `/research-education/library/protocol/${resourceSlug}`
      }
      return buildResourceAssetUrl(typeSlug, resourceSlug)
    }
  }
  return '#'
}
